import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ breakpoints }: Theme) =>
  createStyles({
    refreshButton: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      color: palette.white,
    },
    refreshButtonYellow: {
      backgroundColor: palette.navCompanyContextActions,
    },
    refreshButtonGreen: {
      backgroundColor: palette.navAdminActions,
    },
    refreshButtonBlue: {
      backgroundColor: palette.navOperatorActions,
    },
    refreshButtonGray: {
      backgroundColor: palette.navSuperAdminActions,
    },
    buttonGrid: {
      textAlign: 'center',
      justifyContent: 'center',
    },
    table: {
      marginTop: 10,
    },
    cardContainer: {
      display: 'flex',
      alignItems: 'center',
      margin: '10px 5px',
      [breakpoints.down('sm')]: {
        margin: 5,
      },
    },

    pageBody: {
      marginTop: 5,
    },

    sopCardContainer: {
      alignContent: 'center',
      display: 'flow-root',
      alignItems: 'center',
      marginTop: 10,
      marginBottom: 20,
      width: '33%',
      [breakpoints.down('md')]: {
        width: '100%',
      },
    },
    partnerDashboardCardContainer: {
      alignContent: 'center',
      display: 'flow-root',
      alignItems: 'center',
      marginTop: 10,
      height: '100%',
      marginBottom: 20,
      width: '50%',
      [breakpoints.down('md')]: {
        width: '100%',
      },
    },
    fadein: {
      animation: '$fadein 0.7s forwards',
      opacity: 0,
    },

    '@keyframes fadein': {
      '0%': {
        opacity: 0,
      },
      '100%': {
        opacity: 1,
      },
    },
    titleCard: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: palette.darkGray,
      fontSize: 14,
      fontWeight: 500,
      zIndex: 2,
      margin: '10px 0px',
    },
    card: { height: '80%' },
    partnerDashboardCard: { height: '100%' },
    partnerSelector: {
      fontSize: 14,
      color: palette.navCompanyContextActions,
      fontWeight: 550,
      padding: '1px 10px',
    },
    buttonSelectPartner: {
      padding: 1,
      color: palette.navCompanyContextActions,
      borderColor: palette.navCompanyContextActions,
      marginLeft: 5,
    },
    alert: {
      maxWidth: 700,
      width: 'fit-content',
      margin: '0 auto',
      fontSize: 12,
      marginTop: 20,
    },
    closeIcon: { color: palette.error.main },
    applyButton: { borderColor: palette.blue, color: palette.blue },
    filterSelector: {
      '& .MuiOutlinedInput-root': { width: '95%' },
    },
    dateFilters: {
      border: `2px solid ${palette.deepBlue}`,
      padding: 20,
      borderRadius: 10,
    },
    noDateFilters: { marginTop: 15 },
  });

export const overrideCardGraph = (breakpoints): any => ({
  alignItems: 'center',
  display: 'flex',
  [breakpoints.down('md')]: {
    flexFlow: 'column-reverse',
    alignItems: 'baseline',
    justifyContent: 'flex-start',
    height: '100%',
  },
  [breakpoints.down(775)]: {
    flexFlow: 'unset',
    alignItems: 'center',
  },
  [breakpoints.down(575)]: {
    flexFlow: 'column-reverse',
    alignItems: 'baseline',
    justifyContent: 'flex-start',
    height: '100%',
  },
  minHeight: 130,
  '&:after': {
    content: '""',
    position: 'absolute',
    width: 180,
    height: 180,
    borderRadius: '50%',
    zIndex: 1,
    top: -75,
    right: -141,
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    zIndex: 1,
    width: 180,
    height: 180,
    borderRadius: '50%',
    top: -125,
    right: -100,
    opacity: 0.5,
  },
});

export const overrideFilter = {
  text: {
    fontWeight: 500,
    fontSize: 14,
  },
  listItem: { '& .MuiTypography-body1': { fontSize: 14 } },
};
